import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';    
import { HttpClientModule } from '@angular/common/http'; 
import { SharedModule } from '../../shared/shared.module'; 
import { VerificationLoginComponent } from './page/verification-login/verification-login.component';
import { B2cVerificationRoutingModule } from './b2c-verification-routing.module';
const COMPONENTS = [
  VerificationLoginComponent ,
];

@NgModule({
  declarations: [...COMPONENTS],
  imports: [
    CommonModule,
    B2cVerificationRoutingModule,    
    HttpClientModule, 
    SharedModule
  ],
  providers:[ 
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class B2cVerificationModule { }
